import React from 'react';

// ============ ÉLÉMENTS DE BASE (viewBox 48x48 pour plus de détails) ============

const Helmet = () => (
  <>
    {/* Casque jaune */}
    <rect x="11" y="3" width="26" height="3" fill="#f59e0b"/>
    <rect x="9" y="6" width="30" height="4" fill="#f59e0b"/>
    <rect x="8" y="10" width="32" height="2" fill="#d97706"/>
    {/* Lumière frontale */}
    <rect x="21" y="3" width="6" height="3" fill="#fef3c7"/>
    <rect x="22" y="2" width="4" height="1" fill="#fef3c7"/>
    {/* Reflet casque */}
    <rect x="13" y="5" width="3" height="1" fill="#fcd34d"/>
  </>
);

const Head = () => (
  <>
    <rect x="12" y="12" width="24" height="14" fill="#f59e0b"/>
    {/* Oreilles */}
    <rect x="10" y="16" width="3" height="5" fill="#f59e0b"/>
    <rect x="35" y="16" width="3" height="5" fill="#f59e0b"/>
  </>
);

const Boots = () => (
  <>
    <rect x="13" y="40" width="8" height="4" fill="#57534e"/>
    <rect x="27" y="40" width="8" height="4" fill="#57534e"/>
    <rect x="12" y="43" width="9" height="3" fill="#292524"/>
    <rect x="27" y="43" width="9" height="3" fill="#292524"/>
    {/* Semelle */}
    <rect x="11" y="45" width="10" height="1" fill="#1c1917"/>
    <rect x="27" y="45" width="10" height="1" fill="#1c1917"/>
  </>
);

const Vest = ({ color = '#f97316' }: { color?: string }) => (
  <>
    <rect x="10" y="26" width="28" height="14" fill={color}/>
    {/* Bandes réfléchissantes */}
    <rect x="10" y="30" width="28" height="2" fill="#fef08a"/>
    <rect x="10" y="36" width="28" height="2" fill="#fef08a"/>
  </>
);

const EyesOpen = () => (
  <>
    <rect x="15" y="17" width="5" height="4" fill="white"/>
    <rect x="17" y="18" width="3" height="3" fill="#1e293b"/>
    <rect x="17" y="17" width="1" height="1" fill="white"/>
    <rect x="28" y="17" width="5" height="4" fill="white"/>
    <rect x="30" y="18" width="3" height="3" fill="#1e293b"/>
    <rect x="30" y="17" width="1" height="1" fill="white"/>
  </>
);

const EyesClosed = () => (
  <>
    <rect x="14" y="19" width="7" height="1" fill="#78350f"/>
    <rect x="13" y="18" width="2" height="1" fill="#78350f"/>
    <rect x="20" y="18" width="2" height="1" fill="#78350f"/>
    <rect x="27" y="19" width="7" height="1" fill="#78350f"/>
    <rect x="26" y="18" width="2" height="1" fill="#78350f"/>
    <rect x="33" y="18" width="2" height="1" fill="#78350f"/>
  </>
);

const EyesHappy = () => (
  <>
    <rect x="15" y="17" width="5" height="4" fill="white"/>
    <rect x="17" y="18" width="3" height="3" fill="#1e293b"/>
    <rect x="17" y="17" width="2" height="1" fill="white"/>
    <rect x="28" y="17" width="5" height="4" fill="white"/>
    <rect x="30" y="18" width="3" height="3" fill="#1e293b"/>
    <rect x="30" y="17" width="2" height="1" fill="white"/>
  </>
);

const SmileBig = () => (
  <>
    <rect x="18" y="23" width="12" height="2" fill="#78350f"/>
    <rect x="19" y="23" width="10" height="1" fill="#fecaca"/>
  </>
);

const SmileSmall = () => <rect x="20" y="23" width="8" height="1" fill="#78350f"/>;

const MouthOpen = () => (
  <>
    <rect x="20" y="23" width="8" height="3" fill="#78350f"/>
    <rect x="21" y="23" width="6" height="2" fill="#fecaca"/>
  </>
);

const Nose = () => <rect x="22" y="21" width="4" height="2" fill="#d97706"/>;

const Hands = ({ color = '#fbbf24' }: { color?: string }) => (
  <>
    <rect x="6" y="34" width="4" height="4" fill={color}/>
    <rect x="38" y="34" width="4" height="4" fill={color}/>
  </>
);

// ============ POSES ============

export const PoseSleeping: React.FC<{ color?: string }> = ({ color = '#f97316' }) => (
  <g>
    <Helmet/><Head/><Nose/><EyesClosed/><MouthOpen/>
    <Vest color={color}/>
    {/* Bras croisés sur le corps */}
    <rect x="7" y="28" width="5" height="10" fill={color}/>
    <rect x="36" y="28" width="5" height="10" fill={color}/>
    <rect x="15" y="33" width="7" height="3" fill="#fbbf24"/>
    <rect x="26" y="33" width="7" height="3" fill="#fbbf24"/>
    <Boots/>
    {/* Zzz qui montent - gros et lisibles */}
    <text x="37" y="10" fill="#93c5fd" fontSize="6" fontWeight="bold" fontFamily="monospace" className="animate-zzz1">z</text>
    <text x="40" y="5" fill="#60a5fa" fontSize="8" fontWeight="bold" fontFamily="monospace" className="animate-zzz2">Z</text>
    <text x="43" y="0" fill="#3b82f6" fontSize="10" fontWeight="bold" fontFamily="monospace" className="animate-zzz3">Z</text>
    {/* Bulle de sommeil */}
    <circle cx="40" cy="14" r="3" fill="white" opacity="0.3" className="animate-zzz1"/>
  </g>
);

export const PoseGuitar: React.FC<{ color?: string }> = ({ color = '#3b82f6' }) => (
  <g>
    <Helmet/><Head/><Nose/><EyesHappy/><SmileBig/>
    <Vest color={color}/>
    {/* Bras gauche sur manche guitare */}
    <rect x="4" y="27" width="7" height="4" fill={color}/>
    <rect x="3" y="30" width="5" height="3" fill="#fbbf24"/>
    {/* Guitare - corps */}
    <rect x="0" y="22" width="7" height="12" fill="#92400e"/>
    <rect x="1" y="23" width="5" height="10" fill="#78350f"/>
    {/* Guitare - rosace */}
    <rect x="2" y="26" width="3" height="3" fill="#451a03"/>
    {/* Guitare - manche */}
    <rect x="3" y="18" width="2" height="5" fill="#78350f"/>
    <rect x="2" y="16" width="4" height="3" fill="#92400e"/>
    {/* Cordes */}
    <rect x="3" y="20" width="1" height="12" fill="#e5e7eb"/>
    <rect x="4" y="20" width="1" height="12" fill="#d1d5db"/>
    {/* Bras droit */}
    <rect x="37" y="27" width="6" height="5" fill={color}/>
    <rect x="39" y="31" width="4" height="3" fill="#fbbf24"/>
    <Boots/>
    {/* Notes de musique - grosses */}
    <text x="39" y="14" fill="#c084fc" fontSize="8" className="animate-note1">♪</text>
    <text x="43" y="8" fill="#a855f7" fontSize="10" className="animate-note2">♫</text>
    <text x="37" y="5" fill="#7c3aed" fontSize="7" className="animate-note3">♪</text>
  </g>
);

export const PoseCoffee: React.FC<{ color?: string }> = ({ color = '#dc2626' }) => (
  <g>
    <Helmet/><Head/><Nose/>
    {/* Yeux mi-clos relaxé */}
    <rect x="15" y="18" width="5" height="3" fill="white"/>
    <rect x="17" y="18" width="3" height="3" fill="#1e293b"/>
    <rect x="15" y="17" width="5" height="2" fill="#f59e0b"/>
    <rect x="28" y="18" width="5" height="3" fill="white"/>
    <rect x="30" y="18" width="3" height="3" fill="#1e293b"/>
    <rect x="28" y="17" width="5" height="2" fill="#f59e0b"/>
    <SmileSmall/>
    <Vest color={color}/>
    {/* Bras gauche le long du corps */}
    <rect x="6" y="28" width="5" height="10" fill={color}/>
    <rect x="6" y="36" width="4" height="3" fill="#fbbf24"/>
    {/* Bras droit tenant la tasse en haut */}
    <rect x="36" y="22" width="5" height="10" fill={color}/>
    <rect x="38" y="20" width="4" height="3" fill="#fbbf24"/>
    {/* Tasse de café - grosse et claire */}
    <rect x="39" y="14" width="8" height="8" fill="white"/>
    <rect x="40" y="15" width="6" height="6" fill="#78350f"/>
    {/* Anse de la tasse */}
    <rect x="46" y="16" width="2" height="5" fill="white"/>
    <rect x="47" y="17" width="1" height="3" fill="#d1d5db"/>
    {/* Vapeur - grosse */}
    <rect x="41" y="10" width="2" height="3" fill="#94a3b8" className="animate-steam1"/>
    <rect x="44" y="8" width="2" height="3" fill="#94a3b8" className="animate-steam2"/>
    <rect x="42" y="5" width="2" height="3" fill="#cbd5e1" className="animate-steam3"/>
    <Boots/>
  </g>
);

export const PoseHammer: React.FC<{ color?: string }> = ({ color = '#16a34a' }) => (
  <g>
    <Helmet/><Head/><Nose/><EyesOpen/>
    {/* Sourcils froncés */}
    <rect x="14" y="16" width="6" height="1" fill="#78350f"/>
    <rect x="28" y="16" width="6" height="1" fill="#78350f"/>
    <rect x="20" y="24" width="8" height="1" fill="#78350f"/>
    <Vest color={color}/>
    {/* Bras gauche */}
    <rect x="6" y="28" width="5" height="8" fill={color}/>
    <rect x="6" y="35" width="4" height="3" fill="#fbbf24"/>
    {/* Bras droit levé avec marteau */}
    <rect x="36" y="20" width="5" height="12" fill={color}/>
    <rect x="38" y="17" width="4" height="4" fill="#fbbf24"/>
    {/* Manche du marteau */}
    <rect x="38" y="7" width="3" height="11" fill="#92400e"/>
    {/* Tête du marteau - grosse */}
    <rect x="34" y="3" width="10" height="5" fill="#6b7280"/>
    <rect x="34" y="3" width="10" height="2" fill="#9ca3af"/>
    <Boots/>
    {/* Étincelles */}
    <rect x="5" y="38" width="2" height="2" fill="#fef08a" className="animate-spark1"/>
    <rect x="8" y="40" width="2" height="2" fill="#fbbf24" className="animate-spark2"/>
    <rect x="3" y="41" width="2" height="2" fill="#f59e0b" className="animate-spark3"/>
  </g>
);

export const PosePainting: React.FC<{ color?: string }> = ({ color = '#8b5cf6' }) => (
  <g>
    <Helmet/><Head/><Nose/><EyesOpen/><SmileSmall/>
    <Vest color={color}/>
    {/* Bras gauche */}
    <rect x="6" y="28" width="5" height="8" fill={color}/>
    <rect x="6" y="35" width="4" height="3" fill="#fbbf24"/>
    {/* Bras droit avec rouleau */}
    <rect x="36" y="22" width="5" height="10" fill={color}/>
    <rect x="38" y="18" width="3" height="5" fill="#fbbf24"/>
    {/* Manche du rouleau */}
    <rect x="39" y="8" width="2" height="11" fill="#92400e"/>
    {/* Rouleau */}
    <rect x="36" y="4" width="8" height="5" fill="#3b82f6"/>
    <rect x="36" y="4" width="8" height="2" fill="#60a5fa"/>
    <Boots/>
    {/* Gouttes de peinture */}
    <rect x="43" y="10" width="2" height="2" fill="#3b82f6" className="animate-drip"/>
    <rect x="37" y="12" width="2" height="2" fill="#60a5fa" className="animate-spark2"/>
    {/* Éclaboussure au sol */}
    <rect x="2" y="43" width="4" height="2" fill="#93c5fd"/>
    <rect x="7" y="44" width="3" height="1" fill="#60a5fa"/>
  </g>
);

export const PosePhone: React.FC<{ color?: string }> = ({ color = '#0891b2' }) => (
  <g>
    <Helmet/><Head/><Nose/><EyesOpen/><SmileSmall/>
    <Vest color={color}/>
    {/* Bras gauche */}
    <rect x="6" y="28" width="5" height="8" fill={color}/>
    <rect x="6" y="35" width="4" height="3" fill="#fbbf24"/>
    {/* Bras droit tenant téléphone à l'oreille */}
    <rect x="36" y="22" width="5" height="8" fill={color}/>
    <rect x="37" y="18" width="4" height="5" fill="#fbbf24"/>
    {/* Téléphone - gros */}
    <rect x="36" y="12" width="6" height="10" fill="#1e293b"/>
    <rect x="37" y="13" width="4" height="8" fill="#60a5fa"/>
    {/* Écran allumé */}
    <rect x="38" y="14" width="2" height="2" fill="white"/>
    <rect x="38" y="17" width="2" height="1" fill="#94a3b8"/>
    <rect x="38" y="19" width="2" height="1" fill="#94a3b8"/>
    <Boots/>
  </g>
);

export const PosePizza: React.FC<{ color?: string }> = ({ color = '#ea580c' }) => (
  <g>
    <Helmet/><Head/><Nose/><EyesHappy/><SmileBig/>
    <Vest color={color}/>
    {/* Bras gauche */}
    <rect x="6" y="28" width="5" height="8" fill={color}/>
    <rect x="6" y="35" width="4" height="3" fill="#fbbf24"/>
    {/* Bras droit tenant pizza */}
    <rect x="36" y="24" width="5" height="6" fill={color}/>
    <rect x="38" y="20" width="4" height="5" fill="#fbbf24"/>
    {/* Pizza - triangle gros */}
    <rect x="38" y="10" width="10" height="10" fill="#fbbf24"/>
    <rect x="40" y="12" width="6" height="6" fill="#ef4444"/>
    {/* Pepperoni */}
    <rect x="41" y="13" width="2" height="2" fill="#b91c1c"/>
    <rect x="44" y="14" width="2" height="2" fill="#b91c1c"/>
    <rect x="42" y="16" width="2" height="2" fill="#b91c1c"/>
    {/* Fromage qui coule */}
    <rect x="39" y="19" width="2" height="2" fill="#fde68a" className="animate-drip"/>
    <rect x="44" y="18" width="2" height="2" fill="#fde68a"/>
    <Boots/>
  </g>
);

export const PoseDancing: React.FC<{ color?: string }> = ({ color = '#e11d48' }) => (
  <g>
    <Helmet/><Head/><Nose/><EyesHappy/><SmileBig/>
    <Vest color={color}/>
    {/* Bras gauche levé */}
    <rect x="3" y="22" width="8" height="5" fill={color}/>
    <rect x="2" y="20" width="4" height="4" fill="#fbbf24"/>
    {/* Bras droit levé */}
    <rect x="37" y="20" width="8" height="5" fill={color}/>
    <rect x="42" y="18" width="4" height="4" fill="#fbbf24"/>
    {/* Jambe gauche normale */}
    <rect x="13" y="40" width="8" height="4" fill="#57534e"/>
    <rect x="12" y="43" width="9" height="3" fill="#292524"/>
    {/* Jambe droite levée */}
    <rect x="30" y="38" width="8" height="4" fill="#57534e"/>
    <rect x="31" y="41" width="9" height="3" fill="#292524"/>
    {/* Notes et étoiles */}
    <text x="1" y="16" fill="#c084fc" fontSize="8" className="animate-note1">♪</text>
    <text x="43" y="14" fill="#a855f7" fontSize="10" className="animate-note2">♫</text>
    {/* Étoiles */}
    <text x="6" y="10" fill="#fbbf24" fontSize="6" className="animate-spark1">★</text>
    <text x="40" y="8" fill="#fbbf24" fontSize="6" className="animate-spark3">★</text>
  </g>
);

export const PoseSweeping: React.FC<{ color?: string }> = ({ color = '#65a30d' }) => (
  <g>
    <Helmet/><Head/><Nose/><EyesOpen/><SmileSmall/>
    <Vest color={color}/>
    {/* Deux bras sur le balai */}
    <rect x="7" y="28" width="5" height="8" fill={color}/>
    <rect x="8" y="35" width="4" height="3" fill="#fbbf24"/>
    <rect x="36" y="28" width="5" height="8" fill={color}/>
    <rect x="35" y="35" width="4" height="3" fill="#fbbf24"/>
    {/* Manche du balai */}
    <rect x="22" y="14" width="3" height="30" fill="#92400e"/>
    {/* Tête du balai */}
    <rect x="16" y="42" width="15" height="4" fill="#a3a3a3"/>
    <rect x="17" y="45" width="13" height="2" fill="#737373"/>
    {/* Poils du balai */}
    <rect x="16" y="46" width="1" height="2" fill="#525252"/>
    <rect x="19" y="46" width="1" height="2" fill="#525252"/>
    <rect x="22" y="46" width="1" height="2" fill="#525252"/>
    <rect x="25" y="46" width="1" height="2" fill="#525252"/>
    <rect x="28" y="46" width="1" height="2" fill="#525252"/>
    <rect x="30" y="46" width="1" height="2" fill="#525252"/>
    <Boots/>
    {/* Poussière */}
    <rect x="4" y="44" width="3" height="2" fill="#d4d4d4" className="animate-steam1"/>
    <rect x="8" y="42" width="2" height="2" fill="#e5e7eb" className="animate-steam2"/>
  </g>
);

export const PoseLifting: React.FC<{ color?: string }> = ({ color = '#b91c1c' }) => (
  <g>
    <Helmet/><Head/><Nose/><EyesOpen/>
    {/* Sourcils froncés effort */}
    <rect x="14" y="16" width="6" height="1" fill="#78350f"/>
    <rect x="28" y="16" width="6" height="1" fill="#78350f"/>
    {/* Bouche effort */}
    <rect x="19" y="24" width="10" height="2" fill="#78350f"/>
    <Vest color={color}/>
    {/* Deux bras levés */}
    <rect x="4" y="20" width="7" height="8" fill={color}/>
    <rect x="4" y="18" width="4" height="4" fill="#fbbf24"/>
    <rect x="37" y="20" width="7" height="8" fill={color}/>
    <rect x="40" y="18" width="4" height="4" fill="#fbbf24"/>
    {/* Barre d'haltère */}
    <rect x="2" y="16" width="44" height="3" fill="#6b7280"/>
    <rect x="2" y="16" width="44" height="1" fill="#9ca3af"/>
    {/* Poids gauche */}
    <rect x="0" y="12" width="7" height="10" fill="#374151"/>
    <rect x="1" y="13" width="5" height="8" fill="#4b5563"/>
    {/* Poids droit */}
    <rect x="41" y="12" width="7" height="10" fill="#374151"/>
    <rect x="42" y="13" width="5" height="8" fill="#4b5563"/>
    <Boots/>
    {/* Gouttes de sueur */}
    <rect x="10" y="14" width="2" height="2" fill="#93c5fd" className="animate-drip"/>
    <rect x="37" y="12" width="2" height="2" fill="#93c5fd" className="animate-steam2"/>
  </g>
);

// Map des poses disponibles
export const POSE_MAP: Record<string, React.FC<{ color?: string }>> = {
  sleeping: PoseSleeping,
  guitar: PoseGuitar,
  coffee: PoseCoffee,
  hammer: PoseHammer,
  painting: PosePainting,
  phone: PosePhone,
  pizza: PosePizza,
  dancing: PoseDancing,
  sweeping: PoseSweeping,
  lifting: PoseLifting,
};

export const POSE_LABELS: Record<string, string> = {
  sleeping: 'Dort',
  guitar: 'Guitare',
  coffee: 'Café',
  hammer: 'Marteau',
  painting: 'Peinture',
  phone: 'Téléphone',
  pizza: 'Pizza',
  dancing: 'Danse',
  sweeping: 'Balai',
  lifting: 'Force',
};

export const VEST_COLORS = [
  '#f97316', '#3b82f6', '#dc2626', '#16a34a', '#8b5cf6',
  '#0891b2', '#ea580c', '#e11d48', '#65a30d', '#b91c1c',
];
